import axios from "axios";
// import _ from 'lodash';

const baseURL = process.env.REACT_APP_H2O_BACKEND_BASEURL;
const apiKey = process.env.REACT_APP_H2O_API_KEY || "";

// config
const request = axios.create({
  baseURL,
});

const headers = (header) => {
  return {
    headers: {
      "Content-Type": "application/json",
      "x-api-key": apiKey,
      ...(header && header),
    },
  };
};

export const logData = ({ hotel, rsvnNo, progress, date, type, ref }) => {
  const data = { hotel, rsvnNo, progress, type, date, ref };
  request.post("/h2o-ss/log", data, headers({}));
};
